import { z } from 'zod'

export const TelegramWebhookRequest = z.any() // because grammy handler uses there
export type TelegramWebhookRequest = z.infer<typeof TelegramWebhookRequest>

export const TelegramSendChatMessagesRequest = z.object({
  message: z.string(),
  chatIds: z.array(z.string()),
})

export const TelegramSendMessageResult = z.discriminatedUnion('success', [
  z.object({
    chatId: z.string(),
    success: z.literal(true),
    messageId: z.number(),
  }),
  z.object({
    chatId: z.string(),
    success: z.literal(false),
    error: z.string(),
  }),
])

export const TelegramSendChatMessagesResponse = z.object({
  groupId: z.string(),
})

export const TelegramEditChatGroupMessageRequest = z.object({
  newMessage: z.string(),
})

export const TelegramMessageGroupPathParams = z.object({
  groupId: z.string(),
})

export const TelegramEditChatGroupMessageResponse = z.object({
  result: z.array(TelegramSendMessageResult),
})

export const TelegramOutgoingMessageQueueJob = z.discriminatedUnion('type', [
  z.object({
    type: z.literal('add'),
    chatId: z.string(),
    message: z.string(),
    groupId: z.string().nullable(),
  }),
  z.object({
    type: z.literal('edit'),
    chatId: z.string(),
    message: z.string(),
    messageId: z.number(),
  }),
  z.object({
    type: z.literal('delete'),
    chatId: z.string(),
    messageId: z.number(),
  }),
])
